module.exports = __webpack_public_path__ + "img/4000_KMSAT45_2022_Shield.818f01a8.png";